module.exports = __webpack_public_path__ + "img/ElevateCardImage.a6500716.png";